import { getStation } from '@/utils/requestHandler.js'
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner.vue'
import BadRequest from '@/components/Modal/BadRequestModal/BadRequestModal.vue'
import ArrowBack from '../../components/ArrowBack/ArrowBack.vue'

export default {
   name: 'StationDetails',
   components: {
      ArrowBack,
      LoadingSpinner,
      BadRequest
   },
   data() {
      return {
         station: null,
         error: null,
         loading: true
      }
   },
   async created() {
      this.station = await getStation(this.$route.params.code)
      if (typeof this.station == 'string') {
         if (this.station.includes('Request failed') || this.station.toLowerCase().includes('error')) {
            this.error = this.station
            console.log(this.error)
            this.loading = false
         }
      }
      this.loading = false
   }
}
